import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const WallOfLove = React.lazy(() =>
    import('../WallOfLove')
);
const wallOfLoveRoutesRegistry = [
    {
        path: PAGE_URL.WALL_OF_LOVE_PAGE,
        element: <WallOfLove />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default wallOfLoveRoutesRegistry;
